import PropTypes from 'prop-types';
import React from 'react';
import numeral from 'numeral';

const CounterDetails = React.createClass({
  propTypes: {
    metric: PropTypes.object.isRequired,
  },
  render() {
    const metric = this.props.metric.metric;
    return (
      <dl className="metric-def metric-counter">
        <dt>Value:</dt>
        <dd><span className="number-format">{numeral(metric.count).format('0,0')}</span></dd>
      </dl>
    );
  },
});

export default CounterDetails;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/components/metrics/CounterDetails.jsx